module.exports = __webpack_public_path__ + "img/map-circle1.0905c125.svg";